export enum CoursesListDisplayType {
  TIMELINE,
  TABLE,
}
